<template>
  <div>
    <div>
      <HeroBanner
          :background-image="bannerImage"
          title="보청기 A/S 비용"
          sub-title="다비치 히어링 보청기에서 구매한 모든 보청기는 <br>
        전국 매장에서 무료로 사후관리,<br> A/S가 가능합니다."
      />
    </div>

    <div class="as-cost-video">
      <video
          autoplay
          muted
          loop
          playsinline
          preload="auto"
          class="hero-video__player"
      >
        <source src="@/assets/videos/03-02-video.mp4" type="video/mp4">
        브라우저가 비디오를 지원하지 않습니다.
      </video>

    </div>

    <section class="benefit">
      <ul class="benefit__grid">
        <li class="benefit__item">
          <div class="benefit__circle">
            <p class="benefit__text">전국 매장<br />동일 적용</p>
          </div>
        </li>

        <li class="benefit__item">
          <div class="benefit__circle">
            <p class="benefit__text">보증기간 내<br />무료 A/S</p>
          </div>
        </li>

        <li class="benefit__item">
          <div class="benefit__circle">
            <p class="benefit__text">사후 피팅<br />무료 진행</p>
          </div>
        </li>

        <li class="benefit__item">
          <div class="benefit__circle">
            <p class="benefit__text">한달 이내<br />부적응 시<br />100% 환불</p>
          </div>
        </li>
      </ul>
    </section>
<!--    @loadeddata="onVideoLoaded"-->
<!--    @ended="onVideoEnded"-->
<!--    autoplay-->
<!--    -->
  </div>

</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import bannerBg from '@/assets/images/heros/03-top-img.png';

export default {
  name: 'ASCost',
  components: {HeroBanner},
  data() {
    return {
      bannerImage: [bannerBg],
    };
  }
};
</script>

<style scoped lang="scss">
.as-cost-video{
  margin: 56px 0;
  width: 100%;
  video{
    width: 100%;
  }
}

.benefit {
  width: 100%;
}

/* 2x2 그리드 */
.benefit__grid {
  list-style: none;
  margin: 0;
  padding: 0;

  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: clamp(12px, 2vw, 44px);

  /* 가운데 정렬 + 너무 넓어지지 않게 */
  max-width: 900px;
  margin: 36px;
}

/* 아이템 */
.benefit__item {
  display: flex;
  justify-content: center;
}

/* 원형 카드 (반응형 핵심) */
.benefit__circle {
  width: min(340px, 42vw);     /* PC에서는 최대 340px, 화면이 줄면 vw로 같이 줄어듦 */
  aspect-ratio: 1 / 1;         /* 정사각 유지 */
  border-radius: 9999px;
  background: #f4f4f4;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  /* 필요 시 그림자/테두리 */
  /* border: 1px solid rgba(0,0,0,0.06); */
}

/* 텍스트 */
.benefit__text {
  font-family: font family/Font 1;
  font-weight: font weight/500;
  font-style: Medium;
  font-size: 22px;
  leading-trim: NONE;
  line-height: 32px;
  letter-spacing: -0.66px;
  text-align: center;
  vertical-align: middle;
}

/* 모바일: 1열로 쌓기 */
//@media (max-width: 520px) {
//  .benefit__grid {
//    grid-template-columns: 1fr;
//    gap: 36px;
//  }
//  .benefit__circle {
//    width: min(320px, 86vw);
//  }
//}

@media (max-width: 520px) {
  .benefit__text{
    font-size: 1.1rem;
  }
}

</style>
